import { defineMessages } from 'react-intl';

type MessageKeys = 'selectAgentLabel' | 'defaultAgentName';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		selectAgentLabel: {
			id: 'ai-mate.inline-chat-input.agent-selector.select-agent',
			defaultMessage: 'Select agent, current agent is {agentName}',
			description:
				'Accessible label for the button to the left of the chat input that opens the agent selector. Announces the currently active agent.',
		},
		defaultAgentName: {
			id: 'ai-mate.inline-chat-input.agent-selector.default-agent-name',
			defaultMessage: 'Rovo',
			description:
				'Name shown in the agent selector when the user has not picked a specific agent, so the default Rovo assistant handles the prompt.',
		},
	});

export default message;
